export const SUPPORT_EMAIL = 'support@bridgerpay.com';
